module.exports = __webpack_public_path__ + "images/emoji/black_nib.7dd570f5f9d1bbc77a94.png";